export const videoController = (): void => {
  const videoElement = document.querySelectorAll('.js-video') as unknown as HTMLElement[]

  if (videoElement.length <= 0) {
    return
  }

  videoElement.forEach(videoWrapper => {
    const videoTrigger = videoWrapper.querySelector('.js-video-controlTrigger') as HTMLElement

    videoTrigger.addEventListener('click', (e) => {
      e.preventDefault()

      const videoTrigger = videoWrapper.querySelector('.js-video-controlWrappper') as HTMLElement
      videoTrigger.remove()

      const videoContent = videoWrapper.querySelector('.js-video-content') as HTMLVideoElement

      videoContent.classList.remove('-fadedOpacity')
      videoContent.play().catch(e => console.error(e))
    })
  })
}
